import React, { Component } from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import CrewContainer from '../../layouts-components__common-cases/crew-container';

import CommonTitle from '../../../common-components/common-title';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

const webPractik = {
    crewTitle: 'Вебпрактик',
    crewSubtitle: null,
    crewList: [
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img1.png',
            crewItemTitle: 'Василий Кульков',
            crewItemSubtitle: 'старший менеджер проекта',
        },
        {
            crewItemImg: '/images/svg/skolkovo/ace-ventura.jpg',
            crewItemTitle: 'Сергей Волошин',
            crewItemSubtitle: 'старший backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Константин Кулишов',
            crewItemSubtitle: 'старший DevOps-инженер',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Алина Климец',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Сергей Буланов',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Егор Гацон',
            crewItemSubtitle: 'backend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мария Лапиева',
            crewItemSubtitle: 'старший frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Олеся Прокопенко',
            crewItemSubtitle: 'frontend-разработчик',
        },
        {
            crewItemImg: '/images/svg/skolkovo/team__list-img-empty.svg',
            crewItemTitle: 'Мурад Саркаров',
            crewItemSubtitle: 'frontend-разработчик',
        },
    ],
};

class Team extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1.5}>
                <FullWrapper className="team">
                    <CommonTitle>Команда</CommonTitle>
                    <CrewContainer container={webPractik} />
                </FullWrapper>
            </ScrollAnimation>
        );
    }
}

export default Team;
